import './view.scss';
import Splide from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';

function productSliderSplide() {
    let productSliders = document.getElementsByClassName('product-slider__items');
    if (productSliders.length > 0) {
        let options = {
            gap: 0,
            arrows: true,
            pagination: false,
            type: 'slide',
            autoplay: 'pause',
            intersection: {
                inView: {
                    autoplay: true,
                },
                outView: {
                    autoplay: false,
                },
            },
            perMove: 3,
            fixedWidth: '33.33%',
            speed: 1000,
            pauseOnFocus: true,
            pauseOnHover: true,
            breakpoints: {
                390: {
                    fixedWidth: '80%',
                    perMove: 1,
                },
                600: {
                    fixedWidth: '65%',
                    perMove: 1,
                },
                767: {
                    fixedWidth: '42%',
                    perMove: 1,
                },
                992: {
                    fixedWidth: '38%',
                    perMove: 2,
                },
                1400: {
                    fixedWidth: '30%',
                    perMove: 3,
                }
            }
        };

        for (let i = 0; i < productSliders.length; i++) {
            let splide = new Splide(productSliders[i], options);

            splide.on('overflow', function (isOverflow) {
                splide.options = {
                    drag: isOverflow
                };
            });

            splide.mount({Intersection});
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementsByClassName('product-slider').length > 0) {
        productSliderSplide();
    }
});
